import { FilterConfig } from "../components/FiltersBar";
import { SlidersHorizontal } from "lucide-react";
export const filtersConfig: FilterConfig[] = [
  {
    type: "select",
    placeholder: "Category",
    options: [
      { label: "All Categories", value: "all" },
      { label: "Electronics", value: "electronics" },
      { label: "Machinery", value: "machinery" },
      { label: "Textiles", value: "textiles" },
      { label: "Chemicals", value: "chemicals" },
      { label: "Automotive", value: "automotive" },
    ],
  },
  {
    type: "select",
    placeholder: "Location",
    options: [
      { label: "All Locations", value: "all" },
      { label: "United States", value: "us" },
      { label: "China", value: "china" },
      { label: "India", value: "india" },
      { label: "Germany", value: "germany" },
      { label: "United Kingdom", value: "uk" },
    ],
  },
  {
    type: "select",
    placeholder: "Status",
    options: [
      { label: "All Status", value: "all" },
      { label: "Active", value: "active" },
      { label: "Closed", value: "closed" },
      { label: "Expired", value: "expired" },
    ],
  },
  {
    type: "button",
    label: "More Filters",
    variant: "outline",
    icon: SlidersHorizontal,
  },
];
